module.exports = __webpack_public_path__ + "dist/assets/img/ios.603ae63a.svg";